module.exports = __webpack_public_path__ + "static/media/travel3.04e4d26a.jpg";